// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3kB3E","empty":"ModalGraph_empty__sUp0a"};